import Vue from 'vue';

export default {
	install(Vue, store) {

		const gameData = {
		    audios: {},
            bgms: {},
			ended: false,
            ages: null,
            questions: null,
            images: {},
            surveys: {},
            isBadgeShown: false,
		}

		const userData = {
		    testAge: 0,
            testGender: '',
		    gender: '',
		    round: 0,           // 회차
		    age: 0,             // 연령
            sequence: 0,        // 문제 순번
            factor1: 50,         // 팩터1
            factor2: 50,         // 팩터2
            factor3: 50,         // 팩터3
            factor4: 50,         // 팩터4
            penalty: 0,         // 폭탄 갯수
            spouse: 0,          // 배우자 번호
            hasBaby: false,     // 자녀 존재 여부

            question: {},     // 마지막 진행 문항 데이터
            answers: {},        // 교육생 답변 데이터

            ended: false,

            muted: false,

            results: [],        // 게임결과
            badgeCondition: [
                {sequence: '3', option:2, id: 2, value: 1},
                {sequence: '13', option:1, id: 2, value: 1},
                {sequence: '18', option:2, id: 2, value: 1},
                {sequence: '22', option:2, id: 2, value: 1},
                {sequence: '47', option:1, id: 2, value: 1},
                {sequence: '15', option:2, id: 3, value: 1},
                {sequence: '23', option:2, id: 3, value: 1},
                {sequence: '31', option:2, id: 3, value: 1},
                {sequence: '35', option:2, id: 3, value: 1},
                {sequence: '29', option:1, id: 5, value: 1},
                {sequence: '32', option:1, id: 5, value: 1},
                {sequence: '33', option:2, id: 5, value: 1},
                {sequence: '63', option:2, id: 5, value: 1},
                {sequence: '74', option:2, id: 5, value: 1},
                {sequence: '37', option:2, id: 6, value: 1},
                {sequence: '50', option:2, id: 6, value: 1},
                {sequence: '56', option:2, id: 6, value: 1},
                {sequence: '61', option:2, id: 6, value: 1},
                {sequence: '66-1,66-2', option:1, id: 6, value: 1},
                {sequence: '67', option:2, id: 6, value: 1},
                {sequence: '68', option:1, id: 6, value: 1},
                {sequence: '17', option:1, id: 8, value: 1},
                {sequence: '38', option:1, id: 8, value: 1},
                {sequence: '39', option:1, id: 8, value: 1},
                {sequence: '70-1,70-2', option:2, id: 8, value: 1},
                {sequence: '73', option:1, id: 8, value: 1},
                {sequence: '15', option:1, id: 9, value: 1},
                {sequence: '1', option:2, id: 11, value: 1},
                {sequence: '37', option:1, id: 11, value: 1},
                {sequence: '54', option:1, id: 11, value: 1},
                {sequence: '71', option:2, id: 11, value: 1},
                {sequence: '73', option:2, id: 11, value: 1},
                {sequence: '14', option:1, id: 12, value: 1},
                {sequence: '29', option:2, id: 12, value: 1},
                {sequence: '30', option:2, id: 12, value: 1},
                {sequence: '41', option:1, id: 12, value: 1},
                {sequence: '51-1,51-2', option:1, id: 12, value: 1},
                {sequence: '66-1,66-2', option:2, id: 12, value: 1},
                {sequence: '68', option:2, id: 12, value: 1}
            ],
            badgeCount: {
                2: 0,
                3: 0,
                5: 0,
                6: 0,
                8: 0,
                9: 0,
                11: 0,
                12: 0,
            },

            badges: {
                1: false,
                2: false,
                3: false,
                4: false,
                5: false,
                6: false,
                7: false,
                8: false,
                9: false,
                10: false,
                11: false,
                12: false,
            },
        }

        const roundData = {}

        Vue.prototype.$gameData = Vue.observable(gameData)
        Vue.prototype.$userData = Vue.observable(userData)
        Vue.prototype.$roundData = Vue.observable(roundData)

    }
};
